// 50 and 100 because people search the invoice book by paging through it, and
// the SEF portal they compare us with offers up to 100 a page.
export const PAGE_SIZE_OPTIONS = Object.freeze([
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
]);
